// ADHDROOM site chrome: the glass bar, the phone menu, and the cart.
// Loaded on every page (both the ADHDROOM layout and the Studio layout).
//
// The cart is Shopify's real cart, used through the AJAX Cart API:
//   /cart.js         read the cart
//   /cart/add.js     add a variant
//   /cart/change.js  change a line's quantity (0 removes it)
// Any element with data-adr-add="<variant id>" adds that variant when clicked. The product flies into the
// bag in the bar, the bag fills up, a short note confirms it, and the drawer lists everything.
// Checkout goes to Shopify's checkout (/checkout).
// The course is one per person: adding it again only says it is already in the cart, and its line has no "+".
// When something can't be added (sold out, not enough in stock), the note says why and links to the product.
// Prices are written the way the page writes them, in the visitor's currency (samples in the drawer's data-money).

(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- Glass bar: light text over dark sections, dark text over light ones ----------
  var nav = document.getElementById('nav');
  if (!nav) return;
  var darkSections = document.querySelectorAll('.is-dark');
  var ticking = false;
  function updateNav() {
    ticking = false;
    var line = nav.getBoundingClientRect().bottom - 8;
    var overDark = false;
    darkSections.forEach(function (sec) {
      var r = sec.getBoundingClientRect();
      if (r.top <= line && r.bottom > line) overDark = true;
    });
    nav.classList.toggle('is-light', !overDark);
  }
  function requestUpdate() {
    if (!ticking) { ticking = true; requestAnimationFrame(updateNav); }
  }
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  updateNav();

  // ---------- Phone menu ----------
  var navBar = nav.querySelector('.nav');
  var toggle = document.getElementById('menu-toggle');
  function setMenu(open) {
    navBar.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  }
  if (toggle) {
    toggle.addEventListener('click', function () { setMenu(!navBar.classList.contains('is-open')); });
    document.getElementById('nav-links').addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
    document.addEventListener('click', function (e) { if (!e.target.closest('.nav')) setMenu(false); });
  }

  // ---------- The bar must fit: a browser translating the page (Chrome into German, say) makes the names longer.
  // While it doesn't fit, the bar takes the steps in styles.css one at a time (.is-tight, .is-tighter, .is-tightest):
  // on desktop the names move into the menu button's dropdown, on phones the logo and buttons get smaller. Checked
  // again when the window changes size, the fonts arrive, or the translator rewrites the names ----------
  var STEPS = ['is-tight', 'is-tighter', 'is-tightest'];
  var desktop = window.matchMedia('(min-width: 62rem)');
  function fitBar() {
    STEPS.forEach(function (c) { navBar.classList.remove(c); });
    for (var i = 0; i < STEPS.length && navBar.scrollWidth > navBar.clientWidth + 1; i++) navBar.classList.add(STEPS[i]);
    // one row again on a desktop: the dropdown has nothing left to show
    if (toggle && desktop.matches && !navBar.classList.contains('is-tight') && navBar.classList.contains('is-open')) setMenu(false);
  }
  var fitTimer = 0;
  function fitSoon() { clearTimeout(fitTimer); fitTimer = setTimeout(fitBar, 60); }
  fitBar();
  window.addEventListener('resize', fitSoon);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitBar);
  if ('MutationObserver' in window) new MutationObserver(fitSoon).observe(navBar, { childList: true, characterData: true, subtree: true });

  // ---------- Speed: endless background animations (the silk, the pulsing dots, the shine) rest while their
  // section is off screen, so phones only draw what you can see ----------
  if ('IntersectionObserver' in window) {
    var rest = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle('adr-off', !en.isIntersecting); });
    }, { rootMargin: '200px 0px' });
    document.querySelectorAll('main section, main .hero').forEach(function (sec) { rest.observe(sec); });
  }

  // ---------- FAQ (homepage, course page, FAQ page): one answer open at a time in each list ----------
  // "toggle" doesn't bubble, so it's caught on the way down
  document.addEventListener('toggle', function (e) {
    var item = e.target;
    if (!item.open || !item.classList || !item.classList.contains('faq-item') || !item.parentNode) return;
    Array.prototype.forEach.call(item.parentNode.children, function (other) {
      if (other !== item && other.classList.contains('faq-item')) other.open = false;
    });
  }, true);

  // ---------- Reviews: "Read more reviews" shows the next few. When all show, the card reads "Show fewer reviews".
  // Once you've scrolled away from them and the page has stopped moving, they fold back to the first few.
  // If they're above you, the page moves up by exactly what was folded, so what you're reading stays put.
  // (Some browsers keep the place themselves and others, like Safari on iPhone, don't: measuring the first thing
  // after the reviews before and after the fold covers both.) ----------
  function laidOut(el) {
    if (!el.getClientRects().length) return false;
    var pos = getComputedStyle(el).position;
    return pos !== 'fixed' && pos !== 'sticky';
  }
  function nextBlock(el) {
    for (var n = el; n && n !== document.body; n = n.parentElement) {
      for (var s = n.nextElementSibling; s; s = s.nextElementSibling) if (laidOut(s)) return s;
    }
    return null;
  }
  function jumpBy(dy) {
    // a plain jump: the page may ask for smooth scrolling, which would show this correction as a slide
    var html = document.documentElement, was = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, (window.pageYOffset || html.scrollTop) + dy);
    html.style.scrollBehavior = was;
  }
  function foldReviews(btn, grid, sec, toTop) {
    var open = grid.querySelectorAll('[data-review-more]:not([hidden])');
    if (!open.length) return;
    var after = !toTop && sec.getBoundingClientRect().bottom <= 0 ? nextBlock(sec) : null;
    var top0 = after ? after.getBoundingClientRect().top : 0;
    open.forEach(function (r) { r.hidden = true; r.classList.remove('is-new'); r.removeAttribute('tabindex'); });
    btn.classList.remove('is-less');
    btn.querySelector('.review-more-text').textContent = btn.getAttribute('data-more');
    if (after) {
      var moved = after.getBoundingClientRect().top - top0;
      if (Math.abs(moved) > 1) jumpBy(moved);
    }
    if (toTop) sec.scrollIntoView({ block: 'start' });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-reviews-more]');
    if (!btn) return;
    var grid = btn.parentNode;
    var sec = grid.closest('section') || grid;
    if (btn.classList.contains('is-less')) { foldReviews(btn, grid, sec, true); return; }
    var next = grid.querySelectorAll('[data-review-more][hidden]');
    var batch = +btn.getAttribute('data-batch') || 6;
    for (var i = 0; i < next.length && i < batch; i++) { next[i].hidden = false; next[i].classList.add('is-new'); }
    if (next.length <= batch) {
      btn.classList.add('is-less');
      btn.querySelector('.review-more-text').textContent = btn.getAttribute('data-less') || btn.getAttribute('data-more');
    }
    if (!sec.adrFold && 'IntersectionObserver' in window) {
      var wait = null;
      var settle = function () {
        clearTimeout(wait);
        wait = setTimeout(function () {
          window.removeEventListener('scroll', settle);
          var r = sec.getBoundingClientRect();
          if (r.bottom <= 0 || r.top >= window.innerHeight) foldReviews(btn, grid, sec, false);
        }, 350);
      };
      sec.adrFold = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { clearTimeout(wait); window.removeEventListener('scroll', settle); return; }
        window.addEventListener('scroll', settle, { passive: true });
        settle();
      });
      sec.adrFold.observe(sec);
    }
  });

  // ---------- Size pickers on product cards (clothing): "Add to cart" and "Buy now" each open their own row of sizes
  // (.size-open[data-pick] opens .size-pick[data-pick] in the same card; snippet adr-size-pick). A size in the
  // Add to cart row goes into the cart (data-adr-add, below); one in the Buy now row goes straight to checkout.
  // Clicking anywhere else, Esc, or adding something closes it. ----------
  function cardOf(el) { return el.closest('[data-adr-card], .wear-card, .supp'); }
  function pickOf(opener) {
    var card = cardOf(opener);
    var mode = opener.getAttribute('data-pick') || 'add';
    return card && (card.querySelector('.size-pick[data-pick="' + mode + '"]') || (mode === 'add' ? card.querySelector('.size-pick:not([data-pick])') : null));
  }
  function openerOf(pick) {
    var card = cardOf(pick);
    var mode = pick.getAttribute('data-pick') || 'add';
    return card && (card.querySelector('.size-open[data-pick="' + mode + '"]') || (mode === 'add' ? card.querySelector('.size-open:not([data-pick])') : null));
  }
  function closeSizes(except) {
    document.querySelectorAll('.size-pick:not([hidden])').forEach(function (pick) {
      if (pick === except) return;
      pick.hidden = true;
      var opener = openerOf(pick);
      if (opener) opener.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('.size-open');
    if (opener) {
      var pick = pickOf(opener);
      if (!pick) return;
      closeSizes(pick);
      pick.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      var first = pick.querySelector('.size-row a');
      if (first) first.focus({ preventScroll: true });
      return;
    }
    var shut = e.target.closest('.size-close');
    if (shut) {
      var box = shut.closest('.size-pick');
      box.hidden = true;
      var back = openerOf(box);
      if (back) { back.setAttribute('aria-expanded', 'false'); back.focus({ preventScroll: true }); }
      return;
    }
    if (!e.target.closest('.size-pick')) closeSizes();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSizes(); });
  document.addEventListener('adr:adding', function () { closeSizes(); });
  // A size in the Buy now row (data-adr-now="<variant id>") goes straight to checkout with just that size. Its href is
  // only the product page, so bots that follow links never reach a cart (a modified click still opens that page).
  document.addEventListener('click', function (e) {
    var now = e.target.closest('[data-adr-now]');
    if (!now || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    window.location.href = root + 'cart/' + now.getAttribute('data-adr-now') + ':1';
  });

  // ---------- Lift the floating bars (the course price bar, the cart's Checkout bar) above what Shopify puts at the
  // bottom of the screen: the preview bar in theme previews, and the cookie banner (EU/UK only) until the visitor
  // answers it, so "Start my 14 days" is never hidden behind it (owner, 2026-10-26). Shopify hides the banner with
  // display:none on Accept/Decline, which the ResizeObserver sees as size 0, so the bars drop back. ----------
  (function () {
    var html = document.documentElement, watched = [], sizer = null;
    function above(el) {
      if (!el) return 0;
      if (watched.indexOf(el) < 0 && 'ResizeObserver' in window) {
        watched.push(el);
        sizer = sizer || new ResizeObserver(measure);
        sizer.observe(el);
      }
      var r = el.getBoundingClientRect();
      return r.height > 0 && r.top < window.innerHeight ? Math.round(window.innerHeight - r.top) : 0;
    }
    function measure() {
      var pbar = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
      var h = Math.max(above(pbar), above(document.getElementById('shopify-pc__banner')));
      html.style.setProperty('--adr-pbar', h + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
    if ('MutationObserver' in window) {
      var added = new MutationObserver(measure);   // both are added after the page loads
      added.observe(document.body, { childList: true });
      setTimeout(function () { added.disconnect(); }, 30000);
    }
  })();

  // ---------- Footer country picker: choosing a country reloads the page in its currency ----------
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-adr-country]') && e.target.form) e.target.form.submit();
  });

  // ---------- Cart ----------
  var cartBtn = document.getElementById('nav-cart');
  var cartCount = document.getElementById('cart-count');
  var drawer = document.getElementById('cart-drawer');
  var list = document.getElementById('cart-items');
  var subtotal = document.getElementById('cart-subtotal');
  var toast = document.getElementById('cart-toast');
  if (!cartBtn || !drawer) return;

  function api(path, body) {
    var opts = { headers: { 'Accept': 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(root + path, opts).then(function (r) {
      return r.json().then(function (data) { return r.ok ? data : Promise.reject(data); });
    });
  }

  // The header writes 1234.56 in the visitor's currency, the way Shopify writes prices on the page
  // (e.g. "$1,234.56 USD", "1.234,56 € EUR", "¥1,235 JPY"). Every price we draw copies that pattern.
  function moneyPattern(sample) {
    var m = sample && sample.match(/^([^\d]*)1([^\d]?)23[45](?:([^\d])56)?(.*)$/);
    if (!m) return null;
    return { before: m[1], thousands: m[2] || '', decimal: m[3] || '', decimals: m[3] ? 2 : 0, after: m[4] };
  }
  var patterns = {
    plain: moneyPattern(drawer.getAttribute('data-money')),
    full: moneyPattern(drawer.getAttribute('data-money-currency'))
  };
  function money(cents, currency, plain) {
    var p = plain ? patterns.plain : patterns.full;
    if (!p) return (cents / 100).toFixed(2) + (plain ? '' : ' ' + currency);
    var parts = (cents / 100).toFixed(p.decimals).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, p.thousands);
    return p.before + whole + (p.decimals ? p.decimal + parts[1] : '') + p.after;
  }
  // product pages use the same pattern (assets/adr-product.js)
  window.ADRMoney = function (cents, withCurrency) { return money(cents, '', !withCurrency); };

  // One per person: the course (anything sold as an online course)
  function isOnce(item) { return /course/i.test(item.product_type || ''); }
  var lastCart = null;

  function setCount(n) {
    cartCount.textContent = n > 99 ? '99+' : String(n);
    cartBtn.classList.toggle('has-items', n > 0);
    cartBtn.setAttribute('aria-label', n ? 'Cart, ' + n + (n === 1 ? ' item' : ' items') : 'Cart, empty');
    // The bag fills a little more with every item: 1 → 30%, 2 → 51%, 3 → 66% ... never quite overflowing
    cartBtn.style.setProperty('--fill', n ? Math.min(0.94, 1 - Math.pow(0.7, n)).toFixed(3) : '0');
  }

  function render(cart) {
    lastCart = cart;
    setCount(cart.item_count);
    drawer.classList.toggle('is-empty', cart.item_count === 0);
    list.innerHTML = '';
    cart.items.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'cart-item';
      var img = document.createElement('img');
      img.src = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      img.alt = '';
      var info = document.createElement('div');
      info.className = 'ci-info';
      var name = document.createElement('a');
      name.href = item.url;
      name.className = 'ci-name';
      name.textContent = item.product_title;
      info.appendChild(name);
      if (item.variant_title && !item.product_has_only_default_variant && !isOnce(item)) {
        var v = document.createElement('span');
        v.textContent = item.variant_title;
        info.appendChild(v);
      }
      var price = document.createElement('span');
      price.className = 'ci-price';
      price.textContent = money(item.final_line_price, cart.currency);
      info.appendChild(price);
      var qty = document.createElement('div');
      qty.className = 'ci-qty';
      qty.setAttribute('data-key', item.key);
      qty.setAttribute('data-qty', item.quantity);
      qty.innerHTML = '<button type="button" data-step="-1"></button><span></span><button type="button" data-step="1">+</button>';
      qty.children[0].textContent = item.quantity === 1 ? '×' : '−';
      qty.children[0].setAttribute('aria-label', item.quantity === 1 ? 'Remove ' + item.product_title : 'One less ' + item.product_title);
      qty.children[1].textContent = item.quantity;
      qty.children[2].setAttribute('aria-label', 'One more ' + item.product_title);
      if (isOnce(item)) { qty.classList.add('is-once'); qty.removeChild(qty.children[2]); }
      li.appendChild(img); li.appendChild(info); li.appendChild(qty);
      list.appendChild(li);
    });
    subtotal.textContent = money(cart.total_price, cart.currency);
    // Lets the cart page (assets/adr-cart.js) follow changes made in the drawer
    document.dispatchEvent(new CustomEvent('adr:cart', { detail: cart }));
  }

  function refresh() { return api('cart.js').then(function (cart) { render(cart); return cart; }); }

  list.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-step]');
    if (!btn) return;
    var box = btn.parentNode;
    var key = box.getAttribute('data-key');
    var step = btn.getAttribute('data-step');
    var hadFocus = document.activeElement === btn;
    var qty = +box.getAttribute('data-qty') + +step;
    box.classList.add('is-busy');
    api('cart/change.js', { id: key, quantity: Math.max(0, qty) })
      .then(function (cart) {
        render(cart);
        if (!hadFocus) return;
        // the list was redrawn: put the keyboard back on the same button (the next line's, if this one went)
        var row = list.querySelector('[data-key="' + key + '"]');
        var again = (row && (row.querySelector('[data-step="' + step + '"]') || row.querySelector('button'))) ||
          list.querySelector('button[data-step]') || drawer.querySelector('.cart-close');
        if (again) again.focus();
      })
      .catch(function (err) {
        box.classList.remove('is-busy');
        var info = box.parentNode.querySelector('.ci-info');
        var note = info.querySelector('.ci-error');
        if (!note) { note = document.createElement('span'); note.className = 'ci-error'; note.setAttribute('role', 'alert'); info.appendChild(note); }
        note.textContent = (err && typeof err.description === 'string' && err.description) || 'Sorry, that could not be changed.';
      });
  });

  function flyToCart(img, done) {
    if (!img || reduceMotion || !img.animate) { done(); return; }
    var from = img.getBoundingClientRect();
    if (!from.width) { done(); return; }
    var to = cartBtn.getBoundingClientRect();
    var size = Math.min(from.width, from.height, 150);
    var x0 = from.left + from.width / 2 - size / 2;
    var y0 = from.top + from.height / 2 - size / 2;
    var dx = to.left + to.width / 2 - (x0 + size / 2);
    var dy = to.top + to.height / 2 - (y0 + size / 2);
    // a copy of the already-loaded picture, so it shows from the first frame
    var ghost = img.cloneNode(false);
    ghost.removeAttribute('loading'); ghost.removeAttribute('width'); ghost.removeAttribute('height');
    ghost.removeAttribute('srcset'); ghost.removeAttribute('sizes');
    ghost.src = img.currentSrc || img.src;
    ghost.alt = ''; ghost.className = 'cart-ghost' + (img.closest('.course-img') ? ' is-cover' : '');
    ghost.style.cssText = 'left:' + x0 + 'px;top:' + y0 + 'px;width:' + size + 'px;height:' + size + 'px';
    document.body.appendChild(ghost);
    var anim = ghost.animate([
      { transform: 'translate(0, 0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.45 + 'px, ' + (dy * 0.45 - 70) + 'px) scale(0.6)', opacity: 1, offset: 0.5 },
      { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.1)', opacity: 0.6 }
    ], { duration: 800, easing: 'cubic-bezier(0.5, 0, 0.3, 1)' });
    anim.onfinish = function () { ghost.remove(); done(); };
  }

  var toastTimer, toastOut;
  var toastTitle = document.getElementById('ct-title');
  var toastView = document.getElementById('ct-view');
  var toastGo = document.getElementById('ct-go');
  // kind: 'added' (the default), 'already' (the course is in the cart), or 'error' with Shopify's reason
  // and a link to the product page
  function showToast(item, kind, message, href) {
    if (!toast) return;
    kind = kind || 'added';
    var img = document.getElementById('ct-img');
    var pic = item && item.image;
    if (pic) img.src = pic + (pic.indexOf('?') > -1 ? '&' : '?') + 'width=120';
    img.hidden = !pic;
    var label = item && item.product_title ? item.product_title + (item.variant_title && !item.product_has_only_default_variant && !isOnce(item) ? ' · ' + item.variant_title : '') : '';
    toast.classList.toggle('is-error', kind === 'error');
    if (toastTitle) toastTitle.textContent = toastTitle.getAttribute('data-' + kind) || toastTitle.textContent;
    document.getElementById('ct-name').textContent = kind === 'error' ? message : label;
    if (toastView) toastView.hidden = kind === 'error';
    if (toastGo) { toastGo.hidden = !(kind === 'error' && href); if (href) toastGo.href = href; }
    clearTimeout(toastOut);
    toast.classList.remove('is-out');
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, kind === 'error' ? 7000 : 3500);
  }
  function hideToast() {
    if (!toast || toast.hidden) return;
    toast.classList.add('is-out');
    clearTimeout(toastOut);
    toastOut = setTimeout(function () { toast.hidden = true; toast.classList.remove('is-out'); }, 300);
  }

  function bump() { cartBtn.classList.remove('is-bump'); void cartBtn.offsetWidth; cartBtn.classList.add('is-bump'); }

  // Called after anything is added (our buttons, or the theme's own product form)
  function afterAdd(item) {
    refresh().then(function () { bump(); showToast(item); });
  }

  // Add a variant to the cart, fly its picture into the bag, then confirm. Returns a promise.
  // properties (optional): line item properties, like a gift card's recipient
  function addVariant(id, quantity, img, properties) {
    document.dispatchEvent(new CustomEvent('adr:adding'));
    // the course is one per person: if it's already in the cart, say so instead of adding a second
    var ready = lastCart ? Promise.resolve(lastCart) : api('cart.js').catch(function () { return { items: [] }; });
    return ready.then(function (cart) {
      var already = cart.items.filter(function (i) { return i.variant_id === +id && isOnce(i); })[0];
      if (already) { bump(); showToast(already, 'already'); return already; }
      return addNow(id, quantity, img, properties);
    });
  }
  function addNow(id, quantity, img, properties) {
    var item = { id: +id, quantity: quantity || 1 };
    if (properties && Object.keys(properties).length) item.properties = properties;
    return api('cart/add.js', { items: [item] }).then(function (res) {
      var item = res.items ? res.items[0] : res;
      return new Promise(function (resolve) {
        flyToCart(img, function () { afterAdd(item); resolve(item); });
      });
    });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-adr-add]');
    if (!el) return;
    e.preventDefault();
    if (el.classList.contains('is-busy')) return;
    var card = el.closest('[data-adr-card]');
    var img = card ? card.querySelector('[data-adr-img]') : null;
    el.classList.add('is-busy');
    addVariant(el.getAttribute('data-adr-add'), 1, img)
      .catch(function (err) {
        // e.g. sold out, or no more in stock: stay on the page, say why, and offer the product page
        var picture = img ? { image: img.currentSrc || img.src } : null;
        var reason = err && typeof err.description === 'string' && err.description;
        showToast(picture, 'error', reason || (toastTitle && toastTitle.getAttribute('data-retry')) || 'Please try again.', el.getAttribute('data-adr-fallback'));
      })
      .finally(function () { el.classList.remove('is-busy'); });
  });

  var behind = ['nav', 'main', 'MainContent', 'adr-footer', 'cart-toast'];
  function setBehind(off) {
    behind.forEach(function (id) {
      var el = document.getElementById(id) || document.querySelector('.' + id);
      if (el) { if (off) el.setAttribute('inert', ''); else el.removeAttribute('inert'); }
    });
  }
  function openCart() {
    hideToast();
    drawer.hidden = false;
    setBehind(true);
    document.documentElement.classList.add('cart-open');
    cartBtn.setAttribute('aria-expanded', 'true');
    drawer.querySelector('.cart-close').focus();
    refresh();
  }
  function closeCart() {
    if (drawer.hidden) return;
    drawer.hidden = true;
    setBehind(false);
    document.documentElement.classList.remove('cart-open');
    cartBtn.setAttribute('aria-expanded', 'false');
    cartBtn.focus();
  }
  cartBtn.addEventListener('click', openCart);
  var ctView = document.getElementById('ct-view');
  if (ctView) ctView.addEventListener('click', openCart);
  drawer.addEventListener('click', function (e) { if (e.target.closest('[data-cart-close]')) closeCart(); });
  // Empty cart → "Start my 14 days": on the course page, press the page's own buy button (checkout, kept 15% included)
  drawer.addEventListener('click', function (e) {
    var go = e.target.closest('[data-cart-course]');
    var buy = go && document.querySelector('form.cs-form button[type="submit"]');
    if (!buy || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    closeCart();
    buy.click();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  // The theme's own product form (Studio product pages) hands added items to us; the cart page uses render
  window.ADRCart = { open: openCart, refresh: refresh, render: render, afterAdd: afterAdd, add: addVariant };

  // Coming back with the Back button shows the page from the browser's memory: read the cart again
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  refresh();
})();
